/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ArchivedRequestBuilderRequestsMetadata, type ArchivedRequestBuilder } from './archived/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/revisions
 */
export interface RevisionsRequestBuilder extends BaseRequestBuilder<RevisionsRequestBuilder> {
    /**
     * The archived property
     */
    get archived(): ArchivedRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const RevisionsRequestBuilderUriTemplate = "{+baseurl}/files/revisions";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const RevisionsRequestBuilderNavigationMetadata: Record<Exclude<keyof RevisionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    archived: {
        requestsMetadata: ArchivedRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
